import React from 'react'

import {NavLink as RouterNavLink, NavLinkProps, useParams} from 'react-router-dom'

import {useQueryPaginator} from 'src/components/Table'
import {DamagedDetailTable} from 'src/components/Table/detail/Damaged'
import {EventListTable} from 'src/components/Table/list/Event'

import {skuit} from 'src/services/skuit'
import {useQuery} from 'react-query'

import {DetailPage} from 'src/components/Pages/DetailPage'
import {HierarchyPath} from 'src/components/Tree'

const NavLink = React.forwardRef((props: NavLinkProps, ref: React.Ref<HTMLAnchorElement>) => (
  <RouterNavLink innerRef={ref} {...props} />
))
NavLink.displayName = 'NavLink'

interface PathProps {
  guid: string
}

export const DamagedPage = () => {
  const {guid} = useParams<PathProps>()

  const damaged = useQuery(['damaged-details', guid], () =>
    skuit.sc.damaged.retrieve(guid)
  )
  const eventsPaginator = useQueryPaginator('event-list', skuit.sc.events.list, {
    params: {page_size: 5, references: guid},
  })

  const refresh = () => {
    damaged.refetch()
    eventsPaginator.refresh()
  }

  return (
    <>
      <DetailPage
        obj={damaged}
        title="Damaged"
        refresh={refresh}
        breadcrumbs={[{title: 'Dashboard', url: '/'}, {title: 'Damages', url: '/inventory/damages'}]}
        detailComponent={<DamagedDetailTable obj={damaged} menuItems={['print']} refresh={refresh} />}
      >
        <HierarchyPath title="Storage Path" location={damaged} />
        <EventListTable
          paginator={eventsPaginator}
          title="Damage Events"
          fields={['type', 'data', 'by', 'on']}
        />
      </DetailPage>
    </>
  )
}
